import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Box from "../UI/Box";
import { useState } from "react";
import { useEffect } from "react";
import { checkImg } from "../utils/functions";
import j from "../images/i.webp";

function Card({ tag, data }) {
  const [img, setimg] = useState(false);
  useEffect(() => {
    (async function check(i) {
      await fetch(i, {
        method: "HEAD",
      }).then((res) => setimg(res.ok));
    })();
  }, []);
  return (
    <Wrapper>
      <Box shadow={true}>
        <NavLink to={"/"} className="card-image">
          <img src={img || j} alt="" />
        </NavLink>
        <div className="content">
          {tag && (
            <NavLink className={"tag"} to={"/"}>
              {tag}
            </NavLink>
          )}
          <NavLink to={`/posts/${data.id}`} className="title">
            {data.post_title}
          </NavLink>
          <div class="inf">
            <div class="author">
              <a class="css-x0ewr6" href="/author/jane-smith/">
                <strong>{data.post_author_id}</strong>
              </a>
            </div>
            <div class="date">
              <div class="date">
                {new Date(data.post_date).toDateString().slice(3, 100)}
              </div>
              <div class="read flex">
                <img
                  src="https://img.icons8.com/ios-glyphs/30/a0aec0/visible--v1.png"
                  style={{ width: "18px" }}
                />
                {data.post_views_count} min
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Wrapper>
  );
}

export default Card;

const Wrapper = styled.div`
  & > div {
    padding: 8px;
    display: flex;
    border-radius: 16px;
  }
  .card-image {
    flex: 0 0 160px;
    overflow: hidden;
    width: 100%;
  }
  img {
    border-radius: 16px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .content {
    padding: 8px;
    padding-left: 16px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-direction: column;
    .inf {
      font-size: 0.75rem;
      display: flex;
      gap: 4px;
      flex-direction: column;
      a {
        text-decoration: none;
        color: #797979;
      }
      .date {
        color: #a0aec0;
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 6px;
        .read {
          gap: 4px;
        }
      }
    }
  }
  .title {
    font-family: "Libre Baskerville", sans-serif;
    font-weight: bold;
    line-height: 1.33;
    font-size: 1rem;
    text-decoration: none;
    color: #2d3748;
  }
`;
